import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    activationsList: {
        [theme.breakpoints.up('lg')]: {
            position: 'absolute',
            overflowY: 'auto',
            scrollbarWidth: theme.spacing(2.4),
            top: theme.spacing(18),
            bottom: 0,
            left: 0,
            width: '100%'
        }
    }
}));

export default useStyles;
